import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { LabeledInput } from 'components/form-elements/inputs/LabeledInput';
import { LabeledElement } from 'components/form-elements/labels/LabeledElement';

export const RfidTags = () => {

  const formContext = useFormContext();

  return (
    <LabeledElement label="rfIdTags">
      <Controller
        name="rfIdTagOne"
        control={formContext?.control}
        render={({ field: { ref, onChange, value } }) => (
          <LabeledInput
            id="rfId-tag-one"
            value={value}
            inputRef={ref}
            onChange={onChange}
          />
        )}
      />

      <Controller
        name="rfIdTagTwo"
        control={formContext?.control}
        render={({ field: { ref, onChange, value } }) => (
          <LabeledInput
            id="rfId-tag-two"
            value={value}
            inputRef={ref}
            onChange={onChange}
          />
        )}
      />

    </LabeledElement>
  );
};
